import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, getFormValues } from 'redux-form';
import { renderSwitchComponent } from './SwitchPanel';
import getLocaleMessages from '../../utils/localesMessages';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';

const { coverFeesRadio = {} } = getLocaleMessages('buttonsV3/switches');

const CoverFeesSwitch = ({ formValues, showBadge }) => {
  return (
    <Field
      id="coverFeesEnabled"
      name="coverFeesEnabled"
      label="coverFeesEnabled"
      subTitle={coverFeesRadio.tooltip}
      title={coverFeesRadio.label}
      component={renderSwitchComponent}
      isChecked={formValues.coverFeesEnabled === 'yes'}
      showBadge={showBadge}
    />
  );
};

const mapStateToProps = (state) => {
  const { application = {}, buttonFactoryV3 = {} } = state;

  return {
    application,
    buttonFactoryV3,
    formValues: getFormValues(BTN_FACTORY_V3_FORM)(state),
    initialValues: buttonFactoryV3.formattedButton,
  };
};

CoverFeesSwitch.propTypes = {
  formValues: PropTypes.object,
  showBadge: PropTypes.bool,
};

export default connect(mapStateToProps)(CoverFeesSwitch);
